// Reuse Dawn's modal focus trap, Escape handling and scroll lock; gallery is untouched.
if (!customElements.get('mm-size-charts')) {
  customElements.define('mm-size-charts', class extends HTMLElement {
    connectedCallback() { this.modal = this.querySelector('mm-size-chart-modal'); }
    disconnectedCallback() {
      if (this.modal?.hasAttribute('open')) this.modal.hide();
      this.modal?.remove();
    }
  });
}
if (!customElements.get('mm-size-chart-modal')) {
  customElements.define('mm-size-chart-modal', class extends ModalDialog {
    show(opener) {
      const image = this.querySelector('img');
      image.width = Number(opener.dataset.width);
      image.height = Number(opener.dataset.height);
      image.src = opener.dataset.image;
      image.alt = opener.dataset.alt;
      image.style.setProperty('--mm-chart-width', `${opener.dataset.width}px`);
      this.wasLocked = document.body.classList.contains('overflow-hidden');
      super.show(opener);
      this.scrollTop = 0;
      this.querySelector('button').focus();
    }
    hide() {
      super.hide();
      if (this.wasLocked) document.body.classList.add('overflow-hidden');
    }
  });
}
